// CDP-410 - Adding black and white to the color palettes so they can be referenced as a colorScheme.
const colors = {
  black: {
    50: '#FFFFFF',
    100: '#FFFFFF',
    200: '#FFFFFF',
    300: '#FFFFFF',
    400: '#FFFFFF',
    500: '#000000',
    600: '#111111',
    700: '#222222',
    800: '#333333',
    900: '#444444',
  },
  white: {
    50: '#000000',
    100: '#000000',
    200: '#000000',
    300: '#000000',
    400: '#000000',
    500: '#FFFFFF',
    600: '#EEEEEE',
    700: '#DDDDDD',
    800: '#CCCCCC',
    900: '#BBBBBB',
  },
};

export default colors;
